import { createAction } from "redux-actions";

// Get product suite
export const REQUESTED_PRODUCT_SUITES = "REQUESTED_PRODUCT_SUITES";
export const RECEIVED_PRODUCT_SUITES = "RECEIVED_PRODUCT_SUITES";

export const requestProductSuites = createAction(REQUESTED_PRODUCT_SUITES);
export const receiveProductSuites = createAction(
  RECEIVED_PRODUCT_SUITES,
  (productSuites) => ({ productSuites })
);

// Create product suite
export const REQUESTED_CREATE_PRODUCT_SUITE = "REQUESTED_CREATE_PRODUCT_SUITE";
export const RECEIVED_CREATE_PRODUCT_SUITE = "RECEIVED_CREATE_PRODUCT_SUITE";

export const requestCreateProductSuite = createAction(
  REQUESTED_CREATE_PRODUCT_SUITE
);
export const receiveCreateProductSuite = createAction(
  RECEIVED_CREATE_PRODUCT_SUITE,
  (productSuites) => ({ productSuites })
);

// Update product suite
export const REQUESTED_UPDATE_PRODUCT_SUITE = "REQUESTED_UPDATE_PRODUCT_SUITE";
export const RECEIVED_UPDATE_PRODUCT_SUITE = "RECEIVED_UPDATE_PRODUCT_SUITE";

export const requestUpdateProductSuite = createAction(
  REQUESTED_UPDATE_PRODUCT_SUITE
);
export const receiveUpdateProductSuite = createAction(
  RECEIVED_UPDATE_PRODUCT_SUITE,
  (productSuites) => ({ productSuites })
);

// Delete product suite
export const REQUESTED_DELETE_PRODUCT_SUITE = "REQUESTED_DELETE_PRODUCT_SUITE";
export const RECEIVED_DELETE_PRODUCT_SUITE = "RECEIVED_DELETE_PRODUCT_SUITE";

export const requestDeleteProductSuite = createAction(
  REQUESTED_DELETE_PRODUCT_SUITE
);
export const receiveDeleteProductSuite = createAction(
  RECEIVED_DELETE_PRODUCT_SUITE,
  (productSuites) => ({ productSuites })
);
